import { useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n";
import { products } from "../../data/products";
import { Reveal, EASE } from "./Reveal";

const FILTERS = ["all", "garments", "bags", "toys"];

export function Lookbook() {
  const { t, lang } = useLang();
  const [active, setActive] = useState("all");

  const items = active === "all" ? products : products.filter((p) => p.cat === active);

  return (
    <section id="lookbook" className="relative py-28 md:py-40 bg-[var(--bg-2)]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <Reveal>
            <p className="eyebrow mb-6">{t.lookbook.eyebrow}</p>
            <h2 className="font-display font-light text-4xl md:text-6xl lg:text-7xl leading-tight tracking-tight">
              {t.lookbook.title}
            </h2>
            <p className="mt-4 text-[var(--ink-2)] max-w-md leading-relaxed">{t.lookbook.sub}</p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="flex flex-wrap gap-2">
              {FILTERS.map((f) => (
                <button
                  key={f}
                  data-testid={`filter-${f}`}
                  onClick={() => setActive(f)}
                  className={`eyebrow px-5 py-2.5 rounded-full border transition-all duration-300 ${
                    active === f
                      ? "bg-[var(--ink)] text-[var(--bg)] border-[var(--ink)]"
                      : "border-[var(--ink)]/20 text-[var(--ink-2)] hover:border-[var(--gold)]"
                  }`}
                >
                  {t.lookbook.filters[f]}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <motion.div
          key={active}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6"
        >
          {items.map((p, i) => (
            <motion.figure
              key={p.id}
              data-testid={`product-${p.id}`}
              initial={{ opacity: 0, y: 26 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: (i % 8) * 0.05, ease: EASE }}
              className="group"
            >
              <div className="editorial-img rounded-sm aspect-[4/5] border border-black/5 bg-white flex items-center justify-center p-3 md:p-4">
                <img
                  src={p.src}
                  alt={lang === "ro" ? p.ro : p.en}
                  loading="lazy"
                  className="max-h-full max-w-full w-auto h-auto object-contain"
                />
              </div>
              <figcaption className="mt-4 flex items-center justify-between gap-3">
                <span className="font-display text-lg leading-none">{lang === "ro" ? p.ro : p.en}</span>
                <span className="eyebrow text-[9px] text-[var(--gold-dark)] shrink-0">{t.lookbook.filters[p.cat]}</span>
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
